import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store/store";

export interface IShippingRule {
  id: string;
  fromWeight?: number;
  fromUnit: string;
  toWeight?: number;
  toUnit: string;
  cost?: number;
  isFromInvalid?: boolean;
  isToInvalid?: boolean;
}

interface ShippingRulesState {
  shippingRules: IShippingRule[];
}

const initialState: ShippingRulesState = {
  shippingRules: [
    { id: `${Date.now()}`, fromUnit: "lb", toUnit: "lb" },
  ],
};

export const shippingRulesSlice = createSlice({
  name: "shippingRules",
  initialState,
  reducers: {
    setShippingRules: (state, action: PayloadAction<IShippingRule[]>) => {
      state.shippingRules = action.payload;
    },
  },
});

export const { setShippingRules } = shippingRulesSlice.actions;

export default shippingRulesSlice.reducer;
